<section class="content-section" aria-labelledby="not-found-title">
  <p class="eyebrow">404 · Page not found</p>
  <h1 id="not-found-title">We could not find that page.</h1>
  <p>The link may be outdated, or the address may have been mistyped. Choose a destination below to continue.</p>
  <nav class="cta-row" aria-label="Page not found navigation">
    <a class="button-link" routerLink="/ambassadors">Ambassador program</a>
    <a class="button-link secondary" routerLink="/faq">Program FAQ</a>
    <a class="button-link secondary" routerLink="/login">Sign in</a>
  </nav>
</section>
